import { useSelector } from "react-redux";

import LeadMediaVideoOrAudio from "../LeadMediaVideoOrAudio/component";
import { isValidString } from "../../../../utils/content/library";
import { PhotoGallery } from "../../../../components/PhotoGallery/component";
import ImageWrapper from "../../../../components/ImageWrapper/component";
import { withSuspensefulErrorBoundary } from "../../../../components/SuspensefulErrorBoundary/component";

const LeadMedia = () => {
    const leadVideoOrAudio = useSelector(
        (state) => state.detail.leadVideoOrAudio
    );
    const leadImage = useSelector((state) => state.detail.leadImage);
    const leadPhotogallery = useSelector(
        (state) => state.detail.leadPhotogallery
    );

    if (isValidString(leadVideoOrAudio?.clipID)) {
        return <LeadMediaVideoOrAudio />;
    }

    if (isValidString(leadPhotogallery?.id)) {
        return (
            <PhotoGallery
                leadmedia={true}
                photogalleryID={leadPhotogallery.id}
                aspectRatio={leadPhotogallery.aspectRatio}
            />
        );
    }

    if (isValidString(leadImage?.url)) {
        return <ImageWrapper {...leadImage} loading={null} />;
    }

    return null;
};

const SafeLeadMedia = withSuspensefulErrorBoundary(LeadMedia);

export default SafeLeadMedia;
